module.exports = __webpack_public_path__ + "static/media/my-invite.574d0d80.jpg";